import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { environment } from "../../../environments/environment";

/**
 * 🔹 Payload para crear/actualizar
 */
export interface ResultadoPayload {
  descripcion: string;
  estado?: number;
}

/**
 * 🔹 Entidad
 */
export interface Resultado {
  id?: number;
  descripcion: string;
  estado: number;
  fechaCreacion?: string;
  fechaModificacion?: string;
}

/**
 * 🔹 Respuesta genérica
 */
export interface ResultadoResponse {
  id?: number;
  message?: string;
  error?: string;
  data?: any;
  [key: string]: any;
}

@Injectable({
  providedIn: "root",
})
export class ResultadoService {
  private readonly apiUrl = `${environment.apiUrl}/api/resultado`;

  constructor(private http: HttpClient) {}

  /**
   * Obtener todos los resultados
   */
  getAll(): Observable<Resultado[]> {
    return this.http.get<Resultado[]>(this.apiUrl, {
      withCredentials: true,
    });
  }

  /**
   * Obtener resultado por ID
   */
  getById(id: number): Observable<Resultado> {
    return this.http.get<Resultado>(
      `${this.apiUrl}/${id}`,
      {
        withCredentials: true,
      }
    );
  }

  /**
   * Crear resultado
   */
  create(
    payload: ResultadoPayload
  ): Observable<ResultadoResponse> {
    return this.http.post<ResultadoResponse>(
      this.apiUrl,
      payload,
      {
        withCredentials: true,
      }
    );
  }

  /**
   * Actualizar resultado
   */
  update(
    id: number,
    payload: Partial<ResultadoPayload>
  ): Observable<ResultadoResponse> {
    return this.http.put<ResultadoResponse>(
      `${this.apiUrl}/${id}`,
      payload,
      {
        withCredentials: true,
      }
    );
  }

  /**
   * Eliminar resultado
   */
  remove(id: number): Observable<any> {
    return this.http.delete<any>(
      `${this.apiUrl}/${id}`,
      {
        withCredentials: true,
      }
    );
  }

  /**
   * Inactivar resultado
   */
  inactivar(id: number): Observable<ResultadoResponse> {
    return this.http.put<ResultadoResponse>(
      `${this.apiUrl}/${id}/inactivar`,
      {},
      {
        withCredentials: true,
      }
    );
  }

  /**
   * Activar resultado
   */
  activar(id: number): Observable<ResultadoResponse> {
    return this.http.put<ResultadoResponse>(
      `${this.apiUrl}/${id}/activar`,
      {},
      {
        withCredentials: true,
      }
    );
  }
}